// TODO: Get rid of using enums as id link (they could be different from database)
export enum ApOperationMode {
  AppMap = 1,
  Bonitur = 5,
  Const = 6
}
